import kanban from "../assets/img/kanban.png";

export const projectsListFullstack = [
  {
    title: "Kanban app",
    description: "MERN stack, MUI, Redux",
    imgUrl: kanban,
    gitHubUrl: "https://github.com/Martin-J-Larre/kanban-app",
    demoUrl: "https://kanban-app-mern.netlify.app/",
  },
];
